import classNames from 'classnames/bind';
import Card, { CardHeader } from '../../../components/Card';
import styles from './SignUpConfirmation.module.scss';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button';

const cx = classNames.bind(styles);

const SignUpConfirmation = () => {
  const navigate = useNavigate();

  const onReturnToLogIn = () => navigate('/');

  return (
    <div className={cx('signup-confirmation')}>
      <Card className={cx('signup-confirmation__card')}>
        <CardHeader
          title="Your request has been received."
          subtitle="DFIN will contact you soon regarding the acceptance of your sign up and with more information on how to enroll."
          classes={{
            title: cx('signup-confirmation__title'),
            subtitle: cx('signup-confirmation__subtitle'),
          }}
        />
        <Button
          className={cx('signup-confirmation__button')}
          onClick={onReturnToLogIn}
        >
          Return to log in
        </Button>
      </Card>
    </div>
  );
};

export default SignUpConfirmation;
